import { i18n } from '@/plugins/i18n'

export const cardToCardStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
}

export const cardToCardStatusStr = {
    ACTIVE: i18n.t('payman_status.active'),
    PENDING: i18n.t('payman_status.pending'),
    REJECTED: i18n.t('payman_status.rejected'),
    BLOCKED: i18n.t('payman_status.blocked'),
    get(status) {
        let status_str = null;
        Object.keys(cardToCardStatus).forEach(function (item) {
            if(cardToCardStatus[item] === status) {
                status_str = cardToCardStatusStr[item]
            }
        })

        return status_str
    }
}

export const cardToCardVariant = (status) => {
    if(status === cardToCardStatus.ACTIVE) {
        return 'success'
    }

    if(status === cardToCardStatus.REJECTED || status === cardToCardStatus.BLOCKED) {
        return 'danger'
    }

    if(status === cardToCardStatus.PENDING) {
        return 'warning'
    }

    return 'info'
}